import { render, staticRenderFns } from "./InspeccionElementosBotiquin.vue?vue&type=template&id=56d230f6"
import script from "./InspeccionElementosBotiquin.vue?vue&type=script&lang=js"
export * from "./InspeccionElementosBotiquin.vue?vue&type=script&lang=js"
import style0 from "./InspeccionElementosBotiquin.vue?vue&type=style&index=0&id=56d230f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports